// src/keycloak.js
import Keycloak from 'keycloak-js';

// Configuración de Keycloak usando la instancia existente de tu empresa
const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: 'master',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
};

// Inicializar Keycloak
const keycloak = new Keycloak(keycloakConfig);

export default keycloak;